// Authentication Pages
import AdminLogin from "../pages/admin/auth/login";
import FrontLogin from "../pages/auth/Login";
import OtpVerification from "../pages/auth/OtpVerification";
import ResetPassword from "../pages/auth/ResetPassword";
import ForgotPassword from "../pages/auth/ForgotPassword";
import AdminForgotPassword from "../pages/admin/auth/ForgotPassword";
import AcceptUser from "../pages/admin/reset-password/ResetPassword";
import Login from "../pages/auth/Login";
import { userRoutes } from "../pages/admin/modules/users/user.routes";
import { dashboardRoutes } from "../pages/admin/modules/dashboard/dashboard.routes";
import { faqRoutes } from "../pages/admin/modules/Faqs/FaqList/faqs.routes";
import { faqCategoryRoutes } from "../pages/admin/modules/Faqs/FaqCategory/faqCategory.routes";
import { planRoutes } from "../pages/admin/modules/Plan/plan.routes";
import { formRoutes } from "../pages/admin/modules/Forms/forms.routes";
import { editorRoutes } from "../pages/admin/modules/Editor/editor.routes";
import { profileRoutes } from "../pages/admin/modules/profile/profile.routes";
import { taxRoutes } from "../pages/admin/modules/Tax/tax.routes";
import { activityRoutes } from "../pages/admin/modules/Activity/activity.routes";
import { emailTemplateRoutes } from "../pages/admin/modules/EmailTemplate/emailTemplate.routes";
import { siteSettingsRoutes } from "../pages/admin/modules/site-settings/siteSettings.routes";
import { enquiryRoutes } from "../pages/admin/modules/Enquiry/enquiry.routes";
import { pageRoutes } from "../pages/admin/modules/Page/page.routes";
import { discountRoutes } from "../pages/admin/modules/Discount/discount.route";
import { organizationRoutes } from "../pages/admin/modules/Organization/organization.routes";
import { paymentGetwayRoutes } from "../pages/admin/modules/PaymentGetway/paymentGetway.routes";
import { paymentRoutes } from "../pages/admin/modules/Payment/payment.routes";
import { testimonialRoutes } from "../pages/admin/modules/Testimonial/testimonial.routes";
import { howitworksRoutes } from "../pages/admin/modules/HowItWorks/howitworks.routes";
import { blogRoutes } from "../pages/admin/modules/Blogs/BlogsList/blogs.routes";
import { blogCategoryRoutes } from "../pages/admin/modules/Blogs/BlogCategory/blogCategory.routes";
import { blogCommentRoutes } from "../pages/admin/modules/Blogs/BlogComment/blogComment.routes";
import { blogTagsRoutes } from "../pages/admin/modules/Blogs/BlogTags/blogTags.routes";
import { serviceRoutes } from "../pages/admin/modules/Services/ServiceList/service.routes";
import { serviceCategoryRoutes } from "../pages/admin/modules/Services/ServiceCategory/serviceCategory.routes";
import { serviceTagsRoutes } from "../pages/admin/modules/Services/ServiceTags/serviceTags.routes";
import { mediaRoutes } from "../pages/admin/modules/Media/media.routes";
import { classifiedRoutes } from "../pages/admin/modules/Classifieds/ClassifiedList/classifieds.routes";
import { classifiedsCategoryRoutes } from "../pages/admin/modules/Classifieds/ClassifiedCategory/classifiedCategory.routes";
import { classifiedTagsRoutes } from "../pages/admin/modules/Classifieds/ClassifiedTags/classifiedTags.routes";
import { eventCategoryRoutes } from "../pages/admin/modules/Events/EventCategory/eventCategory.routes";
import { eventTagsRoutes } from "../pages/admin/modules/Events/EventTags/eventTags.routes";
import { productRoutes } from "../pages/admin/modules/Products/ProductList/product.routes";
import { productCategoryRoutes } from "../pages/admin/modules/Products/ProductCategory/productCategory.routes";
import { eventRoutes } from "../pages/admin/modules/Events/EventsList/events.routes";
import { jobCategoryRoutes } from "../pages/admin/modules/Jobs/JobCategory/jobCategory.routes";
import { jobTagsRoutes } from "../pages/admin/modules/Jobs/JobTags/jobTags.routes";
import { jobDepartmentRoutes } from "../pages/admin/modules/Jobs/JobDepartment/jobDepartment.routes";
import { jobsApplicationRoutes } from "../pages/admin/modules/Jobs/JobApplication/jobApplication.routes";
import { jobExperienceRoutes } from "../pages/admin/modules/Jobs/JobExperience/jobExperience.routes";
import { jobSalaryRangeRoutes } from "../pages/admin/modules/Jobs/JobSalaryRange/jobSalaryRange.routes";
import { jobSkillRoutes } from "../pages/admin/modules/Jobs/JobSkill/jobSkill.routes";
import { jobQualificationRoutes } from "../pages/admin/modules/Jobs/JobQualification/jobQualification.routes";
import { jobEnquiryRoutes } from "../pages/admin/modules/Jobs/JobEnquiry/jobEnquiry.routes";
import { freelancerCategoryRoutes } from "../pages/admin/modules/Freelancers/FreelancerCategory/freelancerCategory.routes";
import { freelancerTagsRoutes } from "../pages/admin/modules/Freelancers/FreelancerTags/freelancerTags.routes";
import { freelanceBudgetRoutes } from "../pages/admin/modules/Freelancers/FreelanceBudget/freelanceBudget.routes";
import { productTagsRoutes } from "../pages/admin/modules/Products/ProductTags/productTags.routes";
import { jobsRoutes } from "../pages/admin/modules/Jobs/JobList/jobs.routes";
import { freelancerRoutes } from "../pages/admin/modules/Freelancers/FreelancerList/freelancer.routes";
import { freelanceEnquiryRoutes } from "../pages/admin/modules/Freelancers/FreelanceEnquiry/freelanceEnquiry.routes";

import { userDashboardRoutes } from "../pages/user/dashboard/dashboard.routes";
import { jobsListRoutes } from "../pages/user/Jobs/JobsList/jobsList.routes";
import { jobApplyRoutes } from "../pages/user/Jobs/JobApply/jobApply.routes";
import { artistRoutes } from "../pages/admin/modules/users/artist/artist.routes";
import { adminRoutes } from "../pages/admin/modules/users/admin/admin.routes";
import { photoCategoryRoutes } from "../pages/admin/modules/Photos/PhotoCategory/photoCategory.routes";
import { photoTagsRoutes } from "../pages/admin/modules/Photos/PhotoTags/photoTags.routes";
import { photoCommentRoutes } from "../pages/admin/modules/Photos/PhotoComment/photoComment.routes";
import { photoRoutes } from "../pages/admin/modules/Photos/PhotoList/photos.routes";
import { quizRoutes } from "../pages/admin/modules/Quiz/quiz.routes";
import { videoRoutes } from "../pages/admin/modules/Videos/VideoList/videos.routes";
import { videoCommentRoutes } from "../pages/admin/modules/Videos/VideoComment/videoComment.routes";
import { videoCategoryRoutes } from "../pages/admin/modules/Videos/VideoCategory/videoCategory.routes";
import { wheelRoutes } from "../pages/admin/modules/SpinWheel/wheel.routes";
import { leaderboardRoutes } from "../pages/admin/modules/Leaderboard/leaderboard.routes";
import { badgeRoutes } from "../pages/admin/modules/Badge/badge.routes";
import { creditRoutes } from "../pages/admin/modules/Credits/creadits.routes";
import { bubbleRoutes } from "../pages/admin/modules/Bubble/bubble.routes";
import { advertisementRoutes } from "../pages/admin/modules/Advertisement/advertisement.routes";
import Home from "../pages/front/home/";
import Terms from "../components/sections/front/terms";
import Privacy from "../components/sections/front/privacypolicy";


export const authRoutes = (data) => [
  {
    path: "/login",
    title: "login",
    component: Login,
  },
  {
    path: "/accept-user",
    title: "Accept User",
    component: AcceptUser,
  },
  {
    path: "/admin/signin",
    title: "Admin Login",
    component: AdminLogin,
    routeType: "auth",
  },
  {
    path: "/signin",
    title: "signin",
    component: FrontLogin,
    routeType: "auth",
  },
  {
    path: "/account-verification",
    title: "OTP Verification",
    component: OtpVerification,
    routeType: "auth",
  },
  {
    path: "/reset-password",
    title: "Reset Password",
    component: ResetPassword,
    routeType: "auth",
  },
  {
    path: "/forgot-password",
    title: "Forgot Password",
    component: ForgotPassword,
    routeType: "auth",
  },
  {
    path: "/admin/forgot-password",
    title: "Admin Forgot Password",
    component: AdminForgotPassword,
    routeType: "auth",
  },
];

export const frontRoutes = (data) => [
  {
    path: "/",
    title: "Home",
    component: Home,
    layout: "front",
  },
  {
    path: "/terms",
    title: "Terms and Conditions",
    component: Terms,
    layout: "front",
  },
  {
    path: "/privacy-policy",
    title: "Privacy Policy",
    component: Privacy,
    layout: "front",
  },
];

export const routerData = (data) => {
  return [
    ...frontRoutes(data),
    ...authRoutes(data),
    ...dashboardRoutes(data),
    ...userRoutes(data),
    ...artistRoutes(data),
    ...adminRoutes(data),
    ...mediaRoutes(data),
    ...blogRoutes(data),
    ...blogCategoryRoutes(data),
    ...blogTagsRoutes(data),
    ...blogCommentRoutes(data),
    ...photoRoutes(data),
    ...photoCategoryRoutes(data),
    ...photoTagsRoutes(data),
    ...photoCommentRoutes(data),
    ...videoRoutes(data),
    ...videoCommentRoutes(data),
    ...videoCategoryRoutes(data),
    ...quizRoutes(data),
    ...wheelRoutes(data),
    ...classifiedRoutes(data),
    ...classifiedsCategoryRoutes(data),
    ...classifiedTagsRoutes(data),
    ...productRoutes(data),
    ...productCategoryRoutes(data),
    ...eventRoutes(data),
    ...productTagsRoutes(data),
    ...jobsRoutes(data),
    ...jobsApplicationRoutes(data),
    ...jobCategoryRoutes(data),
    ...jobTagsRoutes(data),
    ...jobDepartmentRoutes(data),
    ...jobExperienceRoutes(data),
    ...jobSkillRoutes(data),
    ...jobSalaryRangeRoutes(data),
    ...jobQualificationRoutes(data),
    ...jobEnquiryRoutes(data),
    ...freelancerRoutes(data),
    ...freelancerCategoryRoutes(data),
    ...freelancerTagsRoutes(data),
    ...freelanceEnquiryRoutes(data),
    ...freelanceBudgetRoutes(data),
    ...eventCategoryRoutes(data),
    ...eventTagsRoutes(data),
    ...serviceRoutes(data),
    ...serviceCategoryRoutes(data),
    ...serviceTagsRoutes(data),
    ...faqRoutes(data),
    ...faqCategoryRoutes(data),
    ...testimonialRoutes(data),
    ...howitworksRoutes(data),
    ...planRoutes(data),
    ...formRoutes(data),
    ...editorRoutes(data),
    ...profileRoutes(data),
    ...taxRoutes(data),
    ...activityRoutes(data),
    ...emailTemplateRoutes(data),
    ...siteSettingsRoutes(data),
    ...enquiryRoutes(data),
    ...pageRoutes(data),
    ...discountRoutes(data),
    ...organizationRoutes(data),
    ...paymentGetwayRoutes(data),
    ...paymentRoutes(data),
    ...userDashboardRoutes(data),
    ...jobsListRoutes(data),
    ...jobApplyRoutes(data),
    ...leaderboardRoutes(data),
    ...badgeRoutes(data),
    ...bubbleRoutes(data),
    ...creditRoutes(data),
    ...advertisementRoutes(data),
  ];
};
